import { useGlobal } from '@/utils/useGlobal';
import { useEffect } from 'react';
import css from './index.module.scss';
import EcoImg from 'eco-design/base/eco-img/index2';

export default function D() {
    const { useLang } = useGlobal();
    const { t } = useLang('PowerOcean.D');
    useEffect(() => {
        const AniContainer = window?.AniContainer;
        AniContainer.create({
            syncFromTo: [
                ['.power-ocean-home-D .pc .img-box', { y: -240 }, { y: 0 }],
                ['.power-ocean-home-D .pc .text-box', { y: 0 }, { y: -120 }],
            ],
            triggerElement: '.power-ocean-home-D .pc .img-box',
            triggerHook: 1,
            offset: 0,
            duration: '100%',
            scrollUpdatePos: true,
        });
    }, []);

    return (
        <div className={`power-ocean-home-D ${css['power-ocean-home-D']}`}>
            <div className="sec4 pc">
                <div className="text-box">
                    <div className="text-inner">
                        <div className="left">
                            <p className="sub-title">{t(`label`)}</p>
                            <h2 className="title">{t('title')}</h2>
                        </div>
                        <p className="right">{t('desc')}</p>
                    </div>
                </div>
                <div className="img-box">
                    <EcoImg
                        pc="https://websiteoss.ecoflow.com/upload/image/1768893742594/4.jpg"
                        alt={t`The easiest step to juice up your home with sunshine`}
                    />
                </div>
            </div>

            <div className="sec4 h5">
                <div className="text-box">
                    <div className="left">
                        <p className="sub-title">{t(`label`)}</p>
                        <h2 className="title">{t('title')}</h2>
                    </div>
                    <p className="right">{t('desc')}</p>
                </div>
                <div className="img-box">
                    <EcoImg
                        pc="https://websiteoss.ecoflow.com/upload/image/1768894349509/4.jpg"
                        alt={t`The easiest step to juice up your home with sunshine`}
                    />
                </div>
            </div>
        </div>
    );
}
